var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "ripple",
          rawName: "v-ripple",
          value: _vm.ripple,
          expression: "ripple",
        },
      ],
      staticClass: "calciatore",
      class: _vm.calciatoreClass,
      on: { click: _vm.selected },
    },
    [
      _c("div", { staticClass: "d-flex flex-column" }, [
        _c(
          "div",
          {
            staticClass: "calciatore-maglia",
            style: {
              backgroundImage: _vm.magliaClub,
            },
          },
          [
            !_vm.hideImages
              ? _c("div", { staticClass: "calciatore-sx" }, [
                  _c("div", { staticClass: "imgCalciatore without-ms" }, [
                    _c(
                      "div",
                      { staticClass: "imgContainer imgContainer-ruolo_" },
                      [
                        _vm.Config.AVATAR_OR_FLAG == "avatar"
                          ? _c("div", {
                              key: _vm.thisCalciatore.nid,
                              staticClass: "img",
                              style: {
                                backgroundImage:
                                  "url(" +
                                  (_vm.thisCalciatore.imgCalciatore
                                    ? _vm.thisCalciatore.imgCalciatore
                                    : _vm.Config.PUBLIC_DIR +
                                      "/schede_calciatori/avatar/default/avatar_club_" +
                                      _vm.thisCalciatore.ID_Club +
                                      ".png") +
                                  ")",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.Config.AVATAR_OR_FLAG == "flag"
                          ? _c("div", {
                              key: _vm.thisCalciatore.nid,
                              staticClass: "img flag",
                              style: {
                                backgroundImage:
                                  "url(" +
                                  (_vm.Config.PUBLIC_DIR +
                                    "/clubs/flags/flag_" +
                                    _vm.thisCalciatore.ID_Club +
                                    ".png") +
                                  ")",
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "calciatore-content" }, [
              _c("div", { staticClass: "calciatore-content-sup" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.thisCalciatore.calciatore) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "calciatore-content-inf" }, [
                _vm.thisCalciatore.ID_Club
                  ? _c("span", {}, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.thisCalciatore.nomeClub) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.mantra
                  ? _c(
                      "span",
                      { staticClass: "ruoli-mantra" },
                      _vm._l(
                        _vm.thisCalciatore.mantra_ids,
                        function (mantra_id) {
                          var _obj
                          return _c(
                            "span",
                            {
                              key: mantra_id,
                              staticClass: "ml-1",
                              class:
                                ((_obj = {}),
                                (_obj["ruolo-mantra" + mantra_id] = true),
                                _obj),
                            },
                            [_vm._v(_vm._s(_vm.ruoloMantra(mantra_id)))]
                          )
                        }
                      ),
                      0
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "calciatore-dx" },
              [
                _vm.cal && _vm.cal.p != 0
                  ? _c("span", { staticClass: "pagato mr-3" }, [
                      _vm._v(_vm._s(_vm.cal.p)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.hideEditRemove
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column-reverse justify-center",
                      },
                      [
                        _vm.admin && _vm.cal && _vm.cal.i == 0
                          ? _c(
                              "v-btn",
                              {
                                attrs: {
                                  icon: "",
                                  "x-small": "",
                                  depressed: "",
                                  color: "navy darken-2",
                                },
                                on: { click: _vm.removeCb },
                              },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("close"),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.admin && _vm.cal && _vm.cal.i == 0
                          ? _c(
                              "v-btn",
                              {
                                attrs: {
                                  icon: "",
                                  "x-small": "",
                                  depressed: "",
                                  color: "navy darken-2",
                                },
                                on: { click: _vm.editCb },
                              },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("mode_edit"),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showQuotazione
                  ? _c("span", { staticClass: "Quotazione" }, [
                      _vm._v(
                        "\n          Q " + _vm._s(_vm.thisCalciatore.quotazione)
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showButtonsScartaRiabilita && _vm.scartato
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "cyan white--text ml-4",
                        attrs: {
                          "x-small": "",
                          depressed: "",
                          rounded: "",
                          outlined: "",
                        },
                        on: { click: _vm.removeScartato },
                      },
                      [_vm._v("Riabilita")]
                    )
                  : _vm.showButtonsScartaRiabilita && !_vm.scartato
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "ml-4",
                        attrs: {
                          "x-small": "",
                          depressed: "",
                          rounded: "",
                          outlined: "",
                        },
                        on: { click: _vm.scartaCalciatore },
                      },
                      [_vm._v("Scarta")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showMainStatus
                  ? _c(
                      "div",
                      { staticClass: "mainStatusPlaceholder" },
                      [
                        _c("main-status", {
                          attrs: { ms: _vm.thisCalciatore.ms },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _vm.showStats && _vm.hasStats
          ? _c("div", [
              _vm.thisCalciatore.ID_Ruolo == 1
                ? _c("div", { staticClass: "calciatore-stats" }, [
                    _c(
                      "span",
                      { staticClass: "label" },
                      [_c("v-icon", [_vm._v(" fa-user ")])],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.presenze)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "label" },
                      [_c("v-icon", [_vm._v(" fa-futbol-o ")])],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.golSu)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "label" },
                      [
                        _c("v-img", {
                          staticClass: "rigori",
                          attrs: {
                            src: _vm.firebase_host + "/static/img/rigPa.png",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.rigPa)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "label" },
                      [_c("v-icon", [_vm._v(" fa-star ")])],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.pi)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "label" },
                      [
                        _c("v-img", {
                          staticClass: "cartellini",
                          attrs: {
                            src:
                              _vm.firebase_host + "/static/img/cartellini.png",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.cartellini)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "label" }, [_vm._v("MV")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.mv)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "label" }, [_vm._v("FM")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.fm)),
                    ]),
                  ])
                : _c("div", { staticClass: "calciatore-stats" }, [
                    _c(
                      "span",
                      { staticClass: "label" },
                      [_c("v-icon", [_vm._v(" fa-user ")])],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.presenze)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "label" },
                      [_c("v-icon", [_vm._v(" fa-futbol-o ")])],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.gol)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "label" },
                      [
                        _c("v-img", {
                          staticClass: "rigori",
                          attrs: {
                            src: _vm.firebase_host + "/static/img/rig.png",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.rigori)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "label" },
                      [
                        _c("v-img", {
                          staticClass: "assist",
                          attrs: {
                            src: _vm.firebase_host + "/static/img/assist.png",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.ass)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "label" },
                      [
                        _c("v-img", {
                          staticClass: "cartellini",
                          attrs: {
                            src:
                              _vm.firebase_host + "/static/img/cartellini.png",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.cartellini)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "label" }, [_vm._v("MV")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.mv)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "label" }, [_vm._v("FM")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.fm)),
                    ]),
                  ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }